<span (click)="linkClicked.emit()">{{ text }}</span>
